module.exports = __webpack_public_path__ + "03a7f8749cdc2c25ea8a1982749da222.pdf";